import { VoidFunctionComponent,useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';
import { Navigate, useParams } from 'react-router-dom';
import { Page, PageHeader } from 'components/app';
import { useLocationDescriptor } from 'hooks';
import { getSystemUnauthorized } from 'store/system';
import { RouteContentProps } from './types';
import { getSystemName$ } from '../../../services/auth';
import { Observable, of } from 'rxjs';

export const RouteContent: VoidFunctionComponent<RouteContentProps> = props => {
  const {
    breadcrumbs = [],
    component: Component,
    id,
    layout = true,
    restricted = true,
    title,
  } = props;

  // Build navigator location descriptor for the login page
  const createLoginDescriptor = useLocationDescriptor('auth:login');

  // Retrieve current route params
    const params = useParams();

    const [systemName, setSystemName] = useState<string | null>(null);

    useEffect(() => {
        const systemNameObservable = getSystemName$(); // Directly call the function

        const subscription = systemNameObservable.subscribe({
            next: (name) => setSystemName(name),
            error: (err) => console.error('Error fetching system name', err),
        });

        return () => subscription.unsubscribe(); // Cleanup on unmount
    }, []);

  // Determine if user is currently logged out
  const systemUnauthorized = useSelector(getSystemUnauthorized);

  // Prevent unauthorized users from seeing any actual content if the route is protected
  if (restricted && systemUnauthorized) {
    return <Navigate replace={true} to={createLoginDescriptor()} />;
  }
  
    return layout ? (
        <>
            <Helmet title={title} />
            <Page>
                <PageHeader breadcrumbs={[...breadcrumbs, { id, params }]}>{title}</PageHeader>
                <Component />
            </Page>
            <div
                style={{
                    textAlign: 'center',
                    fontSize: '0.75rem',
                }}
            >
                <strong>Host:</strong> {systemName || 'Loading...'} <br />
                <strong>Date:</strong> {new Date().toLocaleString()}
            </div>
        </>
    ) : (
        <>
            <Helmet title={title} />
            <Component />
        </>
    );
};
 